export const isPlayableClip = (clip) => Boolean(
    clip &&
    !clip.braker &&
    clip.video &&
    clip.video_blocked !== true
);

export const findNearestPlayableClipIndex = (clips, currentIndex = -1) => {
    if (!Array.isArray(clips) || clips.length === 0) return -1;

    for (let index = currentIndex + 1; index < clips.length; index += 1) {
        if (isPlayableClip(clips[index])) return index;
    }

    for (let index = Math.min(currentIndex - 1, clips.length - 1); index >= 0; index -= 1) {
        if (isPlayableClip(clips[index])) return index;
    }

    return -1;
};

export const getClipAccessSummary = (groupedClips, keptIds = null) => {
    const hasKeptFilter = keptIds instanceof Set && keptIds.size > 0;
    const clips = (Array.isArray(groupedClips) ? groupedClips : [])
        .flatMap((group) => Array.isArray(group?.markers) ? group.markers : [])
        .filter((clip) => clip?.video)
        .filter((clip) => !hasKeptFilter || keptIds.has(String(clip?.id)));

    const restrictedClipCount = clips.filter((clip) => clip.video_blocked === true).length;
    const openClipCount = clips.filter((clip) => clip.video_blocked === false).length;
    const totalClipCount = clips.length;

    return {
        totalClipCount,
        restrictedClipCount,
        openClipCount,
        allClipsRestricted: totalClipCount > 0 && restrictedClipCount === totalClipCount,
        hasMixedAccess: restrictedClipCount > 0 && openClipCount > 0,
    };
};
